import { HighlightAdditionalModels } from "flavr-common";
import { InteractionHandler } from "../../Interactions";
import { AddHighlightForModelsMessage, RemoveHighlightsFromModelsMessage } from "../../../../messages/rendering/MeshMessages";
export class HighlightAdditionalModelsInteractionHandler extends InteractionHandler {
    constructor() {
        super(HighlightAdditionalModels.typestatic, [HighlightAdditionalModels.typestatic], [], []);
    }
    onSelect(params, {}, controller) {
        if (HighlightAdditionalModels.is(params)) {
            this.connection.send(new AddHighlightForModelsMessage(controller.uid, params.uids));
        }
    }
    onDeselect(params, {}, controller) {
        if (HighlightAdditionalModels.is(params)) {
            this.connection.send(new RemoveHighlightsFromModelsMessage(controller.uid, params.uids));
        }
    }
}
